import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'dashboard',
        icon: 'ph-squares-four',
        link: '/dashboard',
    },
    {
        id: 2,
        label: 'facilities',
        icon: 'ph-trophy',
        link: '/facilities',
    },
    {
        id: 3,
        label: 'reservations',
        icon: 'ph-calendar-blank',
        link: '/reservations',
    },
    {
        id: 4,
        label: 'invoices',
        icon: 'ph-receipt',
        link: '/invoices',
    },
    {
        id: 5,
        label: 'coupons',
        icon: 'ph-ticket',
        link: '/coupons',
    },
    {
        id: 8,
        label: 'closures',
        icon: 'ph-lock',
        link: '/closures',
    },
    {
        id: 6,
        label: 'users',
        icon: 'ph-users',
        link: '/users',
    },
    {
        id: 7,
        label: 'profile',
        icon: 'ph-user',
        link: '/profile-view',
    },
    // {
    //     id: 8,
    //     label: 'settings',
    //     isTitle: true
    // },
    // {
    //     id: 9,
    //     label: 'cities',
    //     icon: 'ph-buildings',
    //     link: '/cities',
    // }
    // {
    //     id: 8,
    //     label: 'settings',
    //     icon: 'ph-gear',
    //     subItems: [
    //         {
    //             id: 9,
    //             label: 'cities',
    //             link: '/cities',
    //             parentId: 8
    //         }
    //     ]
    // }
]